import React, { useEffect, useState } from 'react'
import Card from '../../../Base/Components/Card/Card'

import { getResumenComprasProducto, getResumenComprasTotal } from '../../../API/Compras/Resumen/ResumenRequests'
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid'
import { Button } from 'primereact/button'
import { AgGridReact } from 'ag-grid-react'
import Loader from '../../../Base/Components/Loader/Loader'

const ResumenComprasScreen = () => {


    const [loading, setLoading] = useState()
    const [dataTotal, setDataProducto] = useState([])
    const [producto, setProducto] = useState([])
    const [dates, setdates] = useState([new Date('2024-01-01'), new Date()])


    const getInfo = async () => {
        setLoading(true)
        const d = await getResumenComprasTotal()
        setDataProducto(d)
        const p = await getResumenComprasProducto()
        setProducto(p)
        setLoading(false)
    }

    const columsTotal = [
        {
            field: 'AgentName',
            header: 'Agente',
            headerEn: '',
            className: '',
            flex: 1,
            rowSpan: (params) => {
                var agente = params.data ? params.data.IdAgent : undefined
                switch (agente) {
                    case 1673:
                        return 3
                        break;

                    case 1619:
                        return 2
                        break;

                    case 2285:
                        return 3
                        break;

                    case 1970:
                        return 2
                        break;

                    case 2332:
                        return 2
                        break;

                    default:
                        return 1
                        break;
                }
            },
            cellClassRules: {
                "cell-span": "value==='Aleksey Nemov' || value==='Ryan Lochte'",
            },
        },
        {
            field: 'PO',
            header: 'No.PO',
            headerEn: '',
            className: 'small',
            Format: 'Currency',
            Sumary: 'sum',
        },
        {
            field: 'TotalLempiras',
            header: 'Lempiras',
            headerEn: '',
            className: 'small',
            Format: 'Currency',
            Sumary: 'sum',
        },
        {
            field: 'TotalDollars',
            header: 'Dollar',
            headerEn: '',
            className: 'small',
            Format: 'Currency',
            Sumary: 'sum',
        },
        {
            field: 'TotalEuros',
            header: 'Euros',
            headerEn: '',
            className: 'small',
            Format: 'Currency',
            Sumary: 'sum',
        },


    ]

    const tableTotal = {
        Columns: columsTotal,
        Data: dataTotal,
        loading: loading
    }

    const columsProducto = [
        {
            field: 'AgentName',
            header: 'Agente',
            headerEn: '',
            className: '',
        },
        {
            field: 'NombreProducto',
            header: 'Producto',
            headerEn: '',
            className: '',
        },
        {
            field: 'CantidadCompras',
            header: 'No PO',
            headerEn: '',
            className: 'small',
            Format: 'Currency',
            Sumary: 'sum',
        },
        {
            field: 'CurrencySymbol',
            header: 'Moneda',
            headerEn: '',
            className: 'XXsmall',
        },
        {
            field: 'Monto',
            header: 'Monto',
            headerEn: '',
            className: 'small',
            Format: 'Currency',
            Sumary: 'sum',
        },
        
        
    ]

    const tableProducto = {
        Columns: columsProducto,
        Data: producto,
        loading: loading
    }

    useEffect(() => {
        getInfo()
    }, [])

    return (
        <div>
            <Loader loading={loading} />
            <Card
                titulo={<div className='d-flex gap'>
                    <h3>Resumen de compras</h3>
                    <Button icon='pi pi-search'  onClick={getInfo}/>
                </div>}
                contenido={
                    <div className='d-flex' style={{ height: '95vh' }}>
                        <div className='pt-4 px-1' style={{ height: '90vh', width: '50%' }}>
                            {/* <AgGridReact
                        rowData={data}
                        columnDefs={colums}
                        suppressRowTransform={true}
                    /> */}
                            <AgGrid table={tableTotal} />
                        </div>
                        <div className='pt-4 px-1' style={{ height: '90vh',  width: '50%' }}>
                                <AgGrid table={tableProducto} />
                        </div>

                    </div>
                }
            />
        </div>
    )
}

export default ResumenComprasScreen